import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';

import { Observable, Subject, Subscription, map } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { isPresent, KeyCodes, stopPropagation, unsubscribe, KeyCode, getKeyCodeFromEvent } from '@fcom/core/utils';

import { TabStateService } from './tab-state.service';

export enum SelectAction {
  PREVIOUS,
  NEXT,
  FIRST,
  LAST,
}

const keyDownToSelectAction: Array<{ key: KeyCode; value: SelectAction }> = [
  { key: KeyCodes.HOME, value: SelectAction.FIRST },
  { key: KeyCodes.END, value: SelectAction.LAST },
];
const keyUpToSelectAction: Array<{ key: KeyCode; value: SelectAction }> = [
  { key: KeyCodes.LEFT, value: SelectAction.PREVIOUS },
  { key: KeyCodes.RIGHT, value: SelectAction.NEXT },
];

@Component({
  selector: 'fin-tab-label',
  styleUrls: ['tab-label.component.scss'],
  templateUrl: 'tab-label.component.html',
  standalone: false,
})
export class TabLabelComponent implements OnInit, OnDestroy {
  private service = inject(TabStateService);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  tabId: string;
  @Input()
  title: string;
  @Input()
  subTitle: string;
  @Input()
  checked: boolean;

  @HostBinding('attr.selected')
  hostSelected = false;
  selected$: Observable<boolean>;
  clicked$: Subject<TabLabelComponent> = new Subject();
  actions$: Subject<SelectAction> = new Subject();

  @ViewChild('content', { static: true })
  private content: ElementRef;
  private subscription: Subscription;

  ngOnInit(): void {
    this.selected$ = this.service.getSelectedTabId().pipe(map((id) => id === this.tabId));
    this.subscription = this.selected$.subscribe((selected: boolean) => (this.hostSelected = selected));
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }

  focus = (): void => this.content.nativeElement.focus();

  onClick(event: MouseEvent): false {
    this.clicked$.next(this);
    return stopPropagation(event);
  }

  onKeyDown = (event: KeyboardEvent): boolean =>
    this.fireAction(
      keyDownToSelectAction.find((keyDown) => keyDown.key === getKeyCodeFromEvent(event)),
      event
    );
  onKeyUp = (event: KeyboardEvent): boolean =>
    this.fireAction(
      keyUpToSelectAction.find((keyUp) => keyUp.key === getKeyCodeFromEvent(event)),
      event
    );

  private fireAction(mode?: { key: KeyCode; value: SelectAction }, event?: Event): boolean {
    if (!isPresent(mode)) {
      return true;
    }
    this.actions$.next(mode.value);
    return stopPropagation(event);
  }
}
